/** Shown when the production bundle has no valid Supabase client env (misconfigured deploy). */
export function ConfigurationMissing() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-[#06040f] px-6 py-12 text-center">
      <h1 className="text-xl font-bold text-white">App configuration incomplete</h1>
      <p className="max-w-md text-sm leading-relaxed text-slate-400">
        This deployment is missing Supabase settings. Add{' '}
        <code className="rounded bg-white/10 px-1.5 py-0.5 text-cyan-200">VITE_SUPABASE_URL</code> and{' '}
        <code className="rounded bg-white/10 px-1.5 py-0.5 text-cyan-200">VITE_SUPABASE_ANON_KEY</code> in your hosting provider’s
        environment variables, then redeploy.
      </p>
      <p className="max-w-md text-xs text-slate-600">
        Values come from Supabase Dashboard → Settings → API. Never commit real keys to git — use env vars only.
      </p>
    </div>
  )
}
